var HistoricModule = /** @class */ (function () {
    function HistoricModule() {
    }
    return HistoricModule;
}());
export { HistoricModule };
